/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/no-children-prop */
/* eslint-disable no-console */
/* eslint-disable sonarjs/no-duplicate-string */
//PS_AD-1
import React from 'react';
import { useState, useEffect, useContext, useRef } from 'react';
import PaymentSchedule from './PaymentSchedule';
import GeneralInformation from './GeneralInformation';
import PaymentCost from './PaymentCost';
import AgreementDetailsProps from './AgreementDetailsInterface';
import 'react-phone-number-input/style.css';
import {
  getPriceQuote,
  SendAutopayText,
  UpdateVehicleInfo,
  GetCustomer,
  getAgreementInfo,
  GenerateAgreementDoc,
  CreateAgreement,
  getPrintDocument,
  GetEmployeeID,
  GetRole,
} from '../../../api/user';
import { ReinstateAgreementContext } from '../../../context/ReinstatementAgreementContext';
import { AgreementContext } from '../../../context/AgreementContext';
import { useHistory } from 'react-router';
import { ReactComponent as Alerticon } from '../../../assets/images/no-records-found.svg';
import {
  Grid,
  Typography,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACSelect,
  RACButton,
  RACRadio,
  RACCheckBox,
  RACModalCard,
  RACTextbox,
  CircularProgress,
} from '@rentacenter/racstrap';
//import '../../styles/agreement.css';
import VoidAgreement from '../../Rental/AddCoCustomer/voidagreement';
import SecondFactor from '../../Rental/TwoFactorPopup/TwoFactorPopup';
import AddCocustomer from '../../Rental/AddCoCustomer/AddCocustomer';
import { agreementGlobalStyles } from '../../../JSstyles/agreementGlobalStyles';
import { autoPayStyles } from '../../../JSstyles/autoPayStyles';
import { useLocation, useParams } from 'react-router-dom';
import { AppRoute } from '../../../config/route-config';
import { SetPendingAgreementValue } from '../../../app/Routes';
import { ContainerContext } from '../../../app/App';
import { CustomPropInterface } from '../../../index';
import CustomerSignature from '../../Shared/CustomerSignature';
import { useTranslation } from 'react-i18next';

interface Params {
  customerId: string;
  agreementId: string;
}
export default function AgreementDetails(props: any) {

  const {i18n, t}= useTranslation('reinstatement');

  const childCompRef: any = useRef();
  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const [CustomerCoverageData, setCustomerCoverageData] = useState();
  const { customerId, agreementId } = useParams<Params>();
  const searching = useLocation().search;
  const transferrightsapplied = new URLSearchParams(searching).get(
    'transferrightsapplied'
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [coCustomerId, setcocustomerId] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [coCustomerName, setcoCustomerName] = useState('');
  const [IsAgreementVoided, setIsAgreementVoided] = useState(false);
  const pulls_data = (data) => {
    setcocustomerId(data.coCustomerId);
    setcoCustomerName(data.coCustomerName);
    props.func({
      coCustomerId: data.coCustomerId,
      coCustomerName: data.coCustomerName,
    });
    // eslint-disable-next-line no-console
    console.log('agreement details contex', data); // LOGS DATA FROM CHILD (My name is Dean Winchester... &)
  };

  const pull_data = (data) => {
    setIsAgreementVoided(data);
    setagreementVoidStatus({ agreementVoidedStatus: true });
    // eslint-disable-next-line no-console
    console.log('agreementDetails void', data); // LOGS DATA FROM CHILD (My name is Dean Winchester... &)
  };
  const history = useHistory();
  const searchAM = useLocation().search;
  const classes = agreementGlobalStyles();
  const autoPayClassName = autoPayStyles();
  const {
    PreviousItemData,
    ItemSearchData,
    CustomerInfo,
    agreementCreateStatus,
    setagreementCreateStatus,
    setagreementVoidStatus,
    agreementVoidStatus,
    reinstateDone,
    setreinstateDone,
    inventoryMapping,
  } = useContext(ReinstateAgreementContext);
  const { CustomerInfoContext } = useContext(AgreementContext);
  const BothCustomer = 'Both customer & co-customer';

  //PS_AD-1 creating object to store customer sign popup input values
  const CustomerSignObj = {
    PresentToSign: BothCustomer,
    SignPlaceChange: '',
    CustomerName: '',
    CoCustomerName: '',
    CustomerPhoneNumber: '',
    CoCustomerPhoneNumber: '',
    CustomerEmail: '',
    CoCustomerEmail: '',
    Reason: '',
    DigitalSignSelected: true,
    DigiSignChecked: true,
    ManualSignChecked: false,
    InStoreChecked: true,
    EmailChecked: false,
    EmailDisabled: false,
  };

  //PS_AD-1 creating object to store payment schedule css class names
  const HighlightCSSObj = {
    WeeklySchedule: false,
    BiWeeklySchedule: false,
    MonthlySchedule: false,
    SemiMonthlySchedule: false,
  };

  const CreateVehicleObj = {
    Make: '',
    Model: '',
    Year: '',
    VIN: '',
    VehicleLicensePlate: '',
  };
  //PS_AD-1 creating object to store all popup completion status
  const PopupCompleteObj = {
    VehicleInfoComplete: false,
    ConfirmDueDateComplete: false,
    CustomerSignComplete: false,
    PrintPopupComplete: false,
    SendAgreementComplete: false,
    AutoPayComplete: false,
    SMSAutheticationComplete: false,
    InitialPaymentComplete: false,
  };
  //PS_AD-1 creating object to store all popup open and close status
  const Popupstatus = {
    ProcessingFeePopupOpen: false,
    LoginOpen: false,
    VehicleInfoOpen: false,
    CreateVehicleOpen: false,
    ConfirmDueDateOpen: false,
    AutoPayOpen: false,
    CustomerSignOpen: false,
    ManualSignAuthenticationOpen: false,
    PrintPopupOpen: false,
    SMSAuthenticationOpen: false,
    SendAgreementOpen: false,
    InitialPaymentOpen: false,
  };
  const VehicleInfoObj = {
    SubmitDisabled: true,
    VehicleChkBox: false,
    ChkBoxIndex: null,
  };
  const CreateVehicleControlsObj = {
    CreateVehicleSubmit: false,
  };
  //PS_AD-1 creating object to store all Autopay Popup actions
  const AutopayObj = {
    AutopayChkBox: false,
    AutoPaySubmitDisable: true,
  };
  //PS_AD-1 creating object to store all SendAgreement popup actions
  const SendAgreemnetObj = {
    SendAgreementEmail: true,
    SendAgreementPrint: false,
    SendAgreementEmailTxt: '',
  };
  const AutopayCustomerInfoObj = {
    CustomerName: '',
    CustomerPhoneNumber: '',
  };
  //PS_AD-1 creating state variable to hold customerSignObj
  const search = useLocation().search;
  const salesLeadId: any = new URLSearchParams(search).get('salesLeadId');
  const [CustomerSign, setCustomerSign]: any = useState(CustomerSignObj);
  const [AutopayCustomerInfo, setAutopayCustomerInfo] = useState(
    AutopayCustomerInfoObj
  );
  //PS_AD-1 creating state variable to hold customerSignObj
  const [tempSchedule, settempSchedule] = useState(HighlightCSSObj);

  //PS_AD-1 creating state to hold Popupstatus
  const [PopupOpen, setPopupOpen] = useState(Popupstatus);

  const [AutoPayToggleStatus, setAutoPayToggleStatus] = useState(false);

  //PS_AD-1 creating state to hold PopupCompleteObj
  const [PopupCompleteStatus, setPopupCompleteStatus] =
    useState(PopupCompleteObj);

  const [VehicleInfoInput, setVehicleInfoInput] = useState(VehicleInfoObj);
  const [CreateVehicleControls, setCreateVehicleControls] = useState(
    CreateVehicleControlsObj
  );
  const [CreateVehicleInputs, setCreateVehicleInputs] =
    useState(CreateVehicleObj);
  //PS_AD-1 creating state variable to hold AutopayObj
  const [AutopayInput, setAutoPayInput] = useState(AutopayObj);
  //PS_AD-1 creating state variable to hold SendAgreemnetObj
  const [SendAgreementInput, setSendAgreementInput] =
    useState(SendAgreemnetObj);
  //PS_AD-1 creating state variable to store all input field edit enable or disable mode
  const [EditDisablemode, setEditDisablemode] =
    useState<AgreementDetailsProps['EditDisablemode']>(true);
  //PS_AD-1 creating state variable to store ext amount
  const [ExtAmt, setExtAmt] = useState();
  //PS_AD-1 creating state variable to store iframe URL
  const [IframeURL, setIframeURL] =
    useState<AgreementDetailsProps['IframeURL']>('');
  //PS_AD-1 creating state variable to store next button clicked status
  const [NextBtnDisabled, setNextBtnDisabled] = useState(true);
  const [NextBtnMessage, setNextBtnMessage] = useState('');
  const [NextBtnClicked, setNextBtnClicked] =
    useState<AgreementDetailsProps['NextBtnClicked']>(false);
  //PS_AD-1 creating state variable to enable tire agreement workflow
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [TireAgreement, setTireAgreement] =
    useState<AgreementDetailsProps['TireAgreement']>(false);
  const [PolicyEnabled, setPolicyEnabled] = useState(false);
  //PS_AD-1 creating state variable to store list of vehicle details
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [VehicleDetailsArray, setVehicleDetailsArray]: any = useState();
  const [VehcileInfoChxboxState, setVehcileInfoChxboxState]: any = useState([]);
  //below state created for demo purpose
  const [PaymentScheduleValues, setPaymentScheduleValues] = useState();
  const [InitialPaymentValues, setInitialPaymentValues] = useState();
  const [TotalPaymentValues, setTotalPaymentValues] = useState();
  const [OtherFeeArray, setOtherFeeArray] = useState();
  const [NextDueDate, setNextDueDate] = useState('');
  const [PayScheduleValues, setPayScheduleValues] = useState();
  const [CreateAgrReqObj, setCreateAgrReqObj]: any = useState({});
  const [GetPriceQuoteRequest, setGetPriceQuoteRequest] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [GenerateDocReq, setGenerateDocReq] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [SendAutopayTextReq, setSendAutopayTextReq] = useState({});
  const [RecalculateLoading, setRecalculateLoading] = useState(false);
  const [LoaderEnabled, setLoaderEnabled] = useState(false);
  const [SomethingWentWrong, setSomethingWentWrong] = useState(false);
  const [AgreementSchedule, setAgreementSchedule] = useState();
  const [EmployerPayschedule, setEmployerPayschedule] = useState();
  const [CalenderDuedate, setCalenderDuedate] = useState('');
  const [AgreementTotal, setAgreementTotal] = useState('');
  const [AgreementId, setAgreementId] = useState('');
  const [CustomerID, setCustomerID] = useState('');
  const [PrimaryCustomerInfo, setPrimaryCustomerInfo]: any = useState();
  const [AgrCustomerObj, setAgrCustomerObj]: any = useState([]);
  const [GlobalCustomerID, setGlobalCustomerID] = useState('');
  const [StoreNumber, setStoreNumber] = useState('');
  const [HiddenLoader, setHiddenLoader] = useState(false);
  const [CreateAgrProcessingPopup, setCreateAgrProcessingPopup] =
    useState(false);
  const [CreateAgrFailPopup, setCreateAgrFailPopup] = useState(false);
  const [SomethingWentWrongOpen, setSomethingWentWrongOpen] = useState(false);
  const [CurrentRole, setCurrentRole] = useState('');
  const [VoidEnabled, setVoidEnabled] = useState(false);
  const [InitialPaymentPaid, setInitialPaymentPaid] = useState(false);
  const [YearOfVehcileArray, setYearOfVehcileArray]: any = useState([
    { value: '2009', label: '2009' },
  ]);
  const [IsPendingAgreement, setIsPendingAgreement] = useState(false);
  const [PendingAgreementOptions, setPendingAgreementOptions] = useState();
  const [PendingAgreementDropdownValues, setPendingAgreementDropdownValues] =
    useState();
  const [ClubStatus, setClubStatus] = useState();
  const [IsLdwTiedWithClub, setIsLdwTiedWithClub] = useState();
  const [LDWstatus, setLDWstatus] = useState();
  const [DeliveryChargeDisable, setDeliveryChargeDisable] = useState(false);
  const [DeliveryChargeFeeValues, setDeliveryChargeFeeValues] = useState([
    '0.00',
  ]);
  const [CreateAgrProcessingMessage, setCreateAgrProcessingMessage] = useState(
    'We are creating the agreement for you!'
  );
  const [CreateAgrFirstFailMessage, setCreateAgrFirstFailMessage] =
    useState('Oops!!');
  const [CreateAgrFailMessage, setCreateAgrFailMessage] = useState(
    'Unable to create agreement at this moment'
  );
  const [documentGenerateCompleted, setdocumentGenerateCompleted] =
    useState(false);
  const [PaymentCostLoading, setPaymentCostLoading] = useState(true);
  const [ClubOriginStore, setClubOriginStore] = useState();
  const CLUB_STATUS_ACTIVE_PENDING = ['A', 'P'];
  const [waiveLDWChecked, setWaiveLDWChecked] = useState(false);
  //Handling Error Message Popup
  const [ApiErrorMsg, setApiErrorMsg] = useState('');
  const [ErrorMsgPopupOpen, setErrorMsgPopupOpen] = useState(false);

  useEffect(() => {
    if (
      ItemSearchData !== undefined &&
      agreementId !== undefined &&
      PreviousItemData !== undefined &&
      inventoryMapping != undefined &&
      !reinstateDone
    ) {
      window.scrollTo(0, 0);
      props.setItemSearchCompleted(true);
      setAgreementId(agreementId);
      const CreateAgreementReq: any = {};
      const Maxyear = new Date().getFullYear();
      const MinYear = Maxyear - 50;
      const VehicleYearArr: any = [{ value: '', label: t('Select') }];
      for (let val = Maxyear; val >= MinYear; val--) {
        const obj = {
          value: val.toString(),
          label: val.toString(),
        };
        VehicleYearArr.push(obj);
      }
      setYearOfVehcileArray(VehicleYearArr);
      if (ItemSearchData !== undefined) {
        // eslint-disable-next-line no-console
        console.log('Itemsearch realese--->', ItemSearchData);
      }
      CreateAgreementReq.coverages = {
        isLdwApplied: true,
        isClubApplied: true,
        isTirepolicyApplied: false,
      };
      let ParseGetPriceQuoteReq: any;
      const ItemSearchVal: any = ItemSearchData;
      setAgreementTotal(ItemSearchVal.AgreementTotal);
      setCustomerID(ItemSearchVal.customerId.toString());
      setStoreNumber(ItemSearchVal.storeNumber);
      // eslint-disable-next-line no-console
      console.log('RawItemSearchInput', ItemSearchVal);
      const GetPriceQuoteReq: any = {
        schedule: null,
        dueDate: '',
        storeNumber: ItemSearchVal.storeNumber,
        customerId: ItemSearchVal.customerId,
        agreementRate: PreviousItemData.PreItemAgreementRate,
        agreementTerm: PreviousItemData.PreItemAgreementTerm,
        isLDWapplied: true,
        isClubApplied: true,
        tireplusPolicy: false,
        sacTotal: PreviousItemData.PreItemSacPrice,
        extensionDays: 0,
        inventoryInfo: ItemSearchVal.inventory,
        parentAgreementId: parseFloat(agreementId),
        reinstate: true,
      };

      // eslint-disable-next-line no-console
      console.log('RawItemSearchInput', ItemSearchVal);
      // eslint-disable-next-line no-console
      console.log('GetPriceReq', GetPriceQuoteReq);
      // eslint-disable-next-line no-console
      console.log('GetPriceRequest', ParseGetPriceQuoteReq);
      // eslint-disable-next-line no-console
      console.log('CreateAgreementReq', CreateAgreementReq);
      const InitialPageLoad = async () => {
        const GetPriceQuoteResponse: any = await getPriceQuote(
          GetPriceQuoteReq
        );
        if (GetPriceQuoteResponse.status === 200) {
          debugger;
          setIsLdwTiedWithClub(
            GetPriceQuoteResponse.data.storeCoverageStatus.isLdwTiedWithClub
          );
          setLDWstatus(
            GetPriceQuoteResponse.data.customerCoverages
              .previousAgreementsLdwStatus
          );
          const CustomerCoverageObj: any = {
            storeCoverageStatus: GetPriceQuoteResponse.data.storeCoverageStatus,
            clubInfo: GetPriceQuoteResponse.data.customerCoverages,
          };
          setCustomerCoverageData(CustomerCoverageObj);
          setClubStatus(
            GetPriceQuoteResponse.data.customerCoverages.clubStatus
          );
          setClubOriginStore(
            GetPriceQuoteResponse.data.customerCoverages.clubOriginStore
          );
          if (
            CLUB_STATUS_ACTIVE_PENDING.includes(
              GetPriceQuoteResponse.data.customerCoverages.clubStatus
            ) ||
            GetPriceQuoteResponse.data.storeCoverageStatus
              .clubOnAgreementCreation === false
          ) {
            GetPriceQuoteReq.isClubApplied = false;
            CreateAgreementReq.coverages.isClubApplied = false;
          }
          if (
            GetPriceQuoteResponse.data.storeCoverageStatus.isLDWAllowed ===
            false
          ) {
            GetPriceQuoteReq.isLDWapplied = false;
            CreateAgreementReq.coverages.isLdwApplied = false;
          }
          if (
            GetPriceQuoteResponse.data.storeCoverageStatus.isLdwTiedWithClub ===
            true &&
            GetPriceQuoteReq.isLDWapplied === false
          ) {
            GetPriceQuoteReq.isClubApplied = false;
            CreateAgreementReq.coverages.isClubApplied = false;
          }
          if (
            ItemSearchVal.TireAgreementFlow === true &&
            GetPriceQuoteResponse.data.storeCoverageStatus.isPolicyAllowed ===
            true
          ) {
            GetPriceQuoteReq.tireplusPolicy = true;
            CreateAgreementReq.coverages.isTirepolicyApplied = true;
            setTireAgreement(true);
            setPolicyEnabled(true);
          }
          if (ItemSearchVal.TireAgreementFlow === true) {
            GetPriceQuoteReq.isLDWapplied = false;
            GetPriceQuoteReq.isClubApplied = false;
            CreateAgreementReq.coverages.isLdwApplied = false;
            CreateAgreementReq.coverages.isClubApplied = false;
          }
        }
        if (
          GetPriceQuoteResponse !== undefined &&
          GetPriceQuoteResponse.status === 200
        ) {
          /* eslint-disable no-console */
          setEditDisablemode(false);
          const GetPriceQuoteBind: any = GetPriceQuoteResponse.data;
          setLoaderEnabled(false);
          console.log('GetPriceQuoteResponse----->', GetPriceQuoteBind);
          const PaymentScheduleVal = GetPriceQuoteBind.paymentSchedule;
          const InitialPaymentVal = GetPriceQuoteBind.agreementInitialPayment;
          const TotalPaymentVal = GetPriceQuoteBind.agreementTotalPayment;
          const RawDueDate = GetPriceQuoteBind.agreementSchedule.dueDate;
          const FeeArr = GetPriceQuoteBind.fees;
          GetPriceQuoteReq.fees = FeeArr.map((ele: any) => {
            return {
              feeAmount: ele.feeAmount,
              feeType: ele.feeType,
            };
          });
          const ConvFeesArr = FeeArr.map((ele: any) => {
            return {
              feeAmount: parseFloat(ele.feeAmount),
              feeType: ele.feeType,
              originalFeeAmount: ele.originalFeeAmount,
            };
          });
          const EmployerPaymentSchedule = GetPriceQuoteBind.employerPayschedule;

          if (
            GetPriceQuoteBind.agreementSchedule !== null &&
            GetPriceQuoteBind.agreementSchedule !== undefined
          ) {
            GetPriceQuoteReq.dueDate =
              GetPriceQuoteBind.agreementSchedule.dueDate;
            GetPriceQuoteReq.schedule =
              GetPriceQuoteBind.agreementSchedule.schedule;
          }

          setGetPriceQuoteRequest(GetPriceQuoteReq);

          setCalenderDuedate(RawDueDate);
          setPaymentScheduleValues(PaymentScheduleVal);
          setInitialPaymentValues(InitialPaymentVal);
          setTotalPaymentValues(TotalPaymentVal);
          setOtherFeeArray(ConvFeesArr);
          setAgreementSchedule(GetPriceQuoteBind.agreementSchedule);
          setEmployerPayschedule(EmployerPaymentSchedule);
          if (GetPriceQuoteBind.deliveryFees.deliveryFeesApplicable === 0) {
            setDeliveryChargeDisable(true);
          }
          setDeliveryChargeFeeValues(GetPriceQuoteBind.deliveryFees.feeAmounts);

          const RawDueDateArr = RawDueDate.split('/');
          console.log('DueDateArray--->', RawDueDateArr);
          const FormatedDuedate =
            RawDueDateArr[2] + '-' + RawDueDateArr[0] + '-' + RawDueDateArr[1];
          setCalenderDuedate(FormatedDuedate);
          const NxtDueDate = ConvertDueDate(RawDueDateArr);
          setNextDueDate(NxtDueDate);
          setPayScheduleValues(GetPriceQuoteBind.paymentSchedule);
          CreateAgreementReq.agreementInfo = {
            schedule:
              GetPriceQuoteBind.agreementSchedule.schedule === 'WK'
                ? 'WK'
                : GetPriceQuoteBind.agreementSchedule.schedule === 'BIWK'
                  ? 'BIWK'
                  : GetPriceQuoteBind.agreementSchedule.schedule === 'MON'
                    ? 'MON'
                    : GetPriceQuoteBind.agreementSchedule.schedule.includes(
                      'SEMI'
                    ) === true
                      ? GetPriceQuoteBind.agreementSchedule.schedule
                      : null,
            agreementType: ItemSearchVal.agreementType,
            // deliveryCharge: 0.0,
            storeNumber: ItemSearchVal.storeNumber,
            agreementSource: salesLeadId === null || undefined ? 'W' : 'I',
            salesPersonId: 98648,
            extensionDays: 0,
            competitor: ItemSearchVal.competitorId,
            duedate: '',
            range: null,
            agreementRate: ItemSearchVal.agreementRate,
            agreementTerm: ItemSearchVal.agreementTerm,
            requestAutopay: false,
            sacPrice: ItemSearchVal.sacPrice,
            agreementDesc: ItemSearchVal.itemDescription,
            salesLeadId: salesLeadId,
            reinstate: true,
            parentAgreementId: parseFloat(agreementId),
            istransferRightsApplied:
              transferrightsapplied != null ? true : false,
          };
          console.log('nhgfredcd inventoryMapping', inventoryMapping);
          CreateAgreementReq.inventoryInfo = inventoryMapping;
          CreateAgreementReq.fees = ConvFeesArr;
          const CustomerArray: any = ItemSearchVal.customer;

          console.log(
            'Create Agreement obj first creation',
            CreateAgreementReq
          );
          if (CustomerInfoContext !== undefined) {
            console.log(
              'CustomerInformation in deatails component',
              CustomerInfoContext[0]
            );
            setGlobalCustomerID(CustomerInfoContext[0].GlobalCustomerID);
            const CustomerRawPhoneNumber =
              CustomerInfoContext[0].CusotmerPhoneNumber;
            const phoneNumber = CustomerRawPhoneNumber.replace(/[^\d]/g, '');
            if (phoneNumber.length === 10) {
              // eslint-disable-next-line prettier/prettier
              const FormatphoneNumber = phoneNumber.replace(
                /(\d{3})(\d{3})(\d{4})/,
                '($1) $2-$3'
              );
              setAutopayCustomerInfo({
                ...AutopayCustomerInfo,
                CustomerName: CustomerInfoContext[0].CustomerName,
                CustomerPhoneNumber: FormatphoneNumber,
              });
              setSendAgreementInput({
                ...SendAgreementInput,
                SendAgreementEmailTxt: CustomerInfoContext[0].CustomerEmail,
              });
            } else {
              setAutopayCustomerInfo({
                ...AutopayCustomerInfo,
                CustomerName: CustomerInfoContext[0].CustomerName,
                CustomerPhoneNumber: CustomerRawPhoneNumber,
              });
              setSendAgreementInput({
                ...SendAgreementInput,
                SendAgreementEmailTxt: CustomerInfoContext[0].CustomerEmail,
              });
            }
          }
          setCreateAgrReqObj(CreateAgreementReq);
          const GenerateAgrReq: any = {};
          GenerateAgrReq.signingUrlRequired = false;
          GenerateAgrReq.signers = [];
          GenerateAgrReq.documentType = [];
          GenerateAgrReq.returnURL = window.location.origin;
          setGenerateDocReq(GenerateAgrReq);
        } else if (GetPriceQuoteResponse.status == 400) {
          const ErrorMessage = GetPriceQuoteResponse?.data?.errors[0]?.error;
          setApiErrorMsg(ErrorMessage);
          setErrorMsgPopupOpen(true);
        } else {
          setSomethingWentWrong(true);
        }
      };

      InitialPageLoad();
    } else if (reinstateDone) {
      props.setItemSearchCompleted(true);
      setCustomerID(customerId);
      setAgreementId(agreementId);
      const AgreementInfoLoad = async () => {
        const agrInfoResponse = await getAgreementInfo(agreementId);
        console.log('agreement info response in agr details ', agrInfoResponse);
        setdocumentGenerateCompleted(true);
        if (agrInfoResponse.status === 200) {
          const agreementInfo = agrInfoResponse.data;
          if (
            agreementInfo.agreementInformation.agreementStatusRefCode === 'VOID'
          ) {
            setIsAgreementVoided(true);
          }
          const paymentSchedule: any = {
            weeklyRate: agreementInfo.agreementInformation.agreementWeeklyRate, //
            weeklyTerm: parseInt(
              agreementInfo.agreementInformation.agreementWeeklyTerm
            ), //
            biweeklyRate:
              agreementInfo.agreementInformation.agreementBiWeeklyRate, //
            biweeklyTerm: parseInt(
              agreementInfo.agreementInformation.agreementBiWeeklyTerm
            ), //
            semimonthlyRate:
              agreementInfo.agreementInformation.agreementSemiMonthlyRate, //
            semimonthlyTerm: parseInt(
              agreementInfo.agreementInformation.agreementSemiMonthlyTerm
            ), //
            monthlyRate:
              agreementInfo.agreementInformation.agreementMonthlyRate, //
            monthlyTerm: parseInt(
              agreementInfo.agreementInformation.agreementMonthlyTerm
            ), //
          };

          const agreementSchedule: any = {
            schedule: agreementInfo.agreementInformation.scheduleRefCode, //
            dueDate: agreementInfo.agreementInformation.dueDate, //
          };

          const agreementInitialPayment: any = {
            rate: agreementInfo.initialPayment.rate, //
            initialRateTax: '0.00', //
            ldw: agreementInfo.initialPayment.ldw, //
            ldwTax: '0.00', //
            policy: agreementInfo.initialPayment.policy, //
            policyTax: '0.00', //
            extensionAmount: agreementInfo.initialPayment.extensionAmount, //
            extensionAmountTax: '0.00', //
            otherFees: agreementInfo.initialPayment.other, //
            otherFeesTax: '0.00', //
            totalTax: agreementInfo.initialPayment.tax, //
            initialPayment: agreementInfo.initialPayment.initialPayment, //
          };

          const agreementTotalPayment: any = {
            initialPaymentTotal: agreementInfo.totalPayment.initialPayment, //
            regularPaymentsCount: agreementInfo.totalPayment.regularTerm, //
            regularPaymentsAmount: agreementInfo.totalPayment.regularPayment, //
            finalPayment: agreementInfo.totalPayment.finalPayment, //
            totalPaymentsCount: agreementInfo.totalPayment.totalTerm, //
            sacTotal: agreementInfo.totalPayment.cashPrice, //
          };

          const employerPayschedule: any = {
            schedule: agreementInfo.agreementInformation.paySchedule, //
            daysPaid: agreementInfo.agreementInformation.payDay, //
          };

          const fees: any[] = []; //

          const fee: any = {
            feeAmount: agreementInfo.initialPayment.other,
            feeType: 'OTHER',
          };

          fees.push(fee);

          const popupCompleted: any = {
            vehicleInfoComplete: true, //
            confirmDueDateComplete: true, //
            customerSignComplete:
              agreementInfo.agreementWorkflow.isAgreementSigned == '1', //
            printPopupComplete:
              agreementInfo.agreementWorkflow.isPrinted == '1', //
            sendAgreementComplete:
              agreementInfo.agreementWorkflow.isPrinted == '1', //
            autoPayComplete: true, //
            SMSAutheticationComplete:
              agreementInfo.agreementWorkflow.isAgreementSigned == '1', //
            initialPaymentComplete:
              agreementInfo.agreementWorkflow.isInitialPaymentPaid == '1',
          };

          const customerInfo = agreementInfo.agreementCustomer.filter(
            (element) => element.priority == '1'
          );
          const coCustomerInfo = agreementInfo.agreementCustomer.filter(
            (element) => element.priority == '2'
          );

          const customers: any = {
            customer: customerInfo.map((ele) => {
              const customer: any = {
                priority: ele.priority,
                customerName: ele.firstName + ' ' + ele.lastName,
                firstName: ele.firstName,
                lastName: ele.lastName,
                customerId: ele.customerId,
                emailAddress: ele.emailId,
                ssn: null,
                gcdid: null,
                phoneNumber: ele.phoneNumber,
                phoneNumbers: getActivePhoneNumber(ele.phoneNumbers),

              };

              return customer;
            }), //
            coCustomer: coCustomerInfo.map((ele) => {
              const coCustomer: any = {
                priority: ele.priority,
                customerName: ele.firstName + ' ' + ele.lastName,
                firstName: ele.firstName,
                lastName: ele.lastName,
                customerId: ele.customerId,
                emailAddress: ele.emailId,
                ssn: null,
                gcdid: null,
                phoneNumber: ele.phoneNumber,
                phoneNumbers: getActivePhoneNumber(ele.phoneNumbers),

              };

              return coCustomer;
            }), //
          };

          const promoCode = agreementInfo.agreementInformation.promoCode
            ? agreementInfo.agreementInformation.promoCode
            : '';
          const promoName = agreementInfo.agreementInformation.promoName
            ? agreementInfo.agreementInformation.promoName
            : '';

          const agreementOption: any = {
            agreementSource: [
              {
                value:
                  agreementInfo.agreementInformation.agreementSourceRefCode, //
                label: agreementInfo.agreementInformation.agreementSource, //
              },
            ],
            optServices: [
              {
                value: agreementInfo.agreementInformation.coverageTypeRefCode, //
                label: agreementInfo.agreementInformation.optServices, //
              },
            ],
            deliveryCharge: [
              {
                value: agreementInfo.agreementInformation.deliveryCharge,
                label: agreementInfo.agreementInformation.deliveryCharge,
              },
            ],
            salesPerson: [
              {
                value:
                  agreementInfo.agreementInformation.salesPersonId.toString(), //
                label: agreementInfo.agreementInformation.salesPerson, //
              },
            ],
            schedule: [
              {
                value: agreementInfo.agreementInformation.scheduleRefCode, //
                label: agreementInfo.agreementInformation.paymentSchedule, //
              },
            ],
            promoCode: [
              {
                value: promoCode, //
                label: promoName, //
              },
            ],
          };

          const generalInformation: any = {
            agreementType: agreementInfo.agreementInformation.agreementType, //
            agreementSourceValue:
              agreementInfo.agreementInformation.agreementSourceRefCode, //
            deliveryChargeValue: parseInt(
              agreementInfo.agreementInformation.deliveryCharge
            ).toString(), //
            daysExtensionValue:
              agreementInfo.agreementInformation.daysExtension, //
            optServicesValue:
              agreementInfo.agreementInformation.coverageTypeRefCode, //
            promoCodeValue: promoCode, //
            policyValue:
              agreementInfo.agreementInformation.policy !== 'N/A'
                ? 'RAC Tire Plus'
                : 'None',
            salesPersonValue:
              agreementInfo.agreementInformation.salesPersonId.toString(), //
            isAutopayEnabled:
              agreementInfo.agreementWorkflow.isAutopayEnabled == '1', //
          };
          const agreementDetailsContext: any = {
            paymentSchedule,
            agreementSchedule,
            agreementInitialPayment,
            agreementTotalPayment,
            employerPayschedule,
            fees,
            policyApplicable:
              agreementInfo.agreementInformation.policy !== 'N/A' ? 1 : 0,
            popupCompleted,
            agreementId: agreementInfo.agreementInformation.agreementId,
            customers,
            agreementOption,
            generalInformation,
            agreementTotal: agreementInfo.totalPayment.totalCost,
          };
          //data set happening from here
          setIsPendingAgreement(true);
          setEditDisablemode(true);
          setDeliveryChargeDisable(true);
          props.setItemSearchCompleted(true);
          // console.log('Im in pending agreement mode', ItemSearchValues);
          console.log('PendingAgreementValues', agreementDetailsContext);
          const PaymentScheduleVal = agreementDetailsContext.paymentSchedule;
          const InitialPaymentVal =
            agreementDetailsContext.agreementInitialPayment;
          const TotalPaymentVal = agreementDetailsContext.agreementTotalPayment;
          const AgreementSchVal = agreementDetailsContext.agreementSchedule;
          const RawDueDate = agreementDetailsContext.agreementSchedule.dueDate;
          const RawDueDateArr = RawDueDate.split('/');
          console.log('DueDateArray--->', RawDueDateArr);
          const FormatedDuedate =
            RawDueDateArr[2] + '-' + RawDueDateArr[0] + '-' + RawDueDateArr[1];
          setCalenderDuedate(FormatedDuedate);

          //need to verify the logic
          const EmployerPaymentSchedule =
            agreementDetailsContext.employerPayschedule.schedule !== null &&
              agreementDetailsContext.employerPayschedule.daysPaid !== null
              ? agreementDetailsContext.employerPayschedule
              : {};
          const GeneralInfoDropdownOptions =
            agreementDetailsContext.agreementOption;
          const PendingGeneralInfoDropdownValue =
            agreementDetailsContext.generalInformation;
          setPaymentScheduleValues(PaymentScheduleVal);
          setInitialPaymentValues(InitialPaymentVal);
          setTotalPaymentValues(TotalPaymentVal);
          setEmployerPayschedule(EmployerPaymentSchedule);
          setAgreementSchedule(AgreementSchVal);
          setPayScheduleValues(PaymentScheduleVal);
          setPendingAgreementOptions(GeneralInfoDropdownOptions);
          setPendingAgreementDropdownValues(PendingGeneralInfoDropdownValue);
          setAgreementTotal(agreementDetailsContext.agreementTotal);
          setAgreementId(agreementDetailsContext.agreementId);
          setCustomerID(
            agreementDetailsContext.customers.customer[0].customerId
          );
          if (agreementDetailsContext.policyApplicable === 1) {
            setPolicyEnabled(true);
          }

          const AgreementCustomers = agreementDetailsContext.customers;
          const Customerdata: any = AgreementCustomers.customer;
          const CoCustomer: any = AgreementCustomers.coCustomer;
          setSendAgreementInput({
            ...SendAgreementInput,
            SendAgreementEmailTxt: Customerdata[0].emailAddress,
          });
          if (CoCustomer.length === 0) {
            const GenerateAgrReq: any = {};
            GenerateAgrReq.signingUrlRequired = false;
            GenerateAgrReq.signers = [];
            GenerateAgrReq.documentType = [];
            GenerateAgrReq.returnURL = window.location.origin;
            setCustomerSign({
              ...CustomerSign,
              CustomerName: Customerdata[0].customerName,
              CustomerPhoneNumber: Customerdata[0].phoneNumber,
              CustomerEmail: Customerdata[0].emailAddress,
              PresentToSign: 'Customer',
            });
            const Customerphonenumber = Customerdata[0]?.phoneNumbers ? Customerdata[0]?.phoneNumbers : Customerdata[0]?.phoneNumber;
            const Convertedphonenumber = Customerphonenumber;
            const CustomerObj = [
              {
                customerId: Customerdata[0].customerId,
                customerName: Customerdata[0].customerName,
                phoneNumber: Convertedphonenumber,
                emailId: Customerdata[0].emailAddress,
                priority: 1,
              },
            ];
            setAgrCustomerObj(CustomerObj);
            GenerateAgrReq.signers = CustomerObj;
            setGenerateDocReq(GenerateAgrReq);
          } else {
            const GenerateAgrReq: any = {};
            GenerateAgrReq.signingUrlRequired = false;
            GenerateAgrReq.signers = [];
            GenerateAgrReq.documentType = [];
            GenerateAgrReq.returnURL = window.location.origin;
            setCustomerSign({
              ...CustomerSign,
              CustomerName: Customerdata[0].customerName,
              CustomerPhoneNumber: Customerdata[0].phoneNumber,
              CustomerEmail: Customerdata[0].emailAddress,
              CoCustomerName: CoCustomer[0].customerName,
              CoCustomerPhoneNumber: CoCustomer[0].phoneNumber,
              CoCustomerEmail: CoCustomer[0].emailAddress,
              PresentToSign: BothCustomer,
              BothCustomerSelected: true,
            });

            const CoCustomerphonenumber = CoCustomer[0]?.phoneNumbers ? CoCustomer[0]?.phoneNumbers : CoCustomer[0]?.phoneNumber;
            const Convertedphonenumber = CoCustomerphonenumber;
            const CustomerObj = [
              {
                customerId: Customerdata[0].customerId,
                customerName: Customerdata[0].customerName,
                phoneNumber: Customerdata[0]?.phoneNumbers ? Customerdata[0]?.phoneNumbers : Customerdata[0]?.phoneNumber,
                emailId: Customerdata[0].emailAddress,
                priority: 1,
              },
              {
                customerId: CoCustomer[0].customerId,
                customerName: CoCustomer[0].customerName,
                phoneNumber: Convertedphonenumber,
                emailId: CoCustomer[0].emailAddress,
                priority: 2,
              },
            ];
            setAgrCustomerObj(CustomerObj);
            GenerateAgrReq.signers = CustomerObj;
            setGenerateDocReq(GenerateAgrReq);
          }
          setPopupCompleteStatus({
            ...PopupCompleteStatus,
            VehicleInfoComplete:
              agreementDetailsContext.popupCompleted.vehicleInfoComplete,
            ConfirmDueDateComplete:
              agreementDetailsContext.popupCompleted.confirmDueDateComplete,
            AutoPayComplete:
              agreementDetailsContext.popupCompleted.autoPayComplete,
            CustomerSignComplete:
              agreementDetailsContext.popupCompleted.customerSignComplete,
            SMSAutheticationComplete:
              agreementDetailsContext.popupCompleted.SMSAutheticationComplete,
            PrintPopupComplete:
              agreementDetailsContext.popupCompleted.printPopupComplete,
            SendAgreementComplete:
              agreementDetailsContext.popupCompleted.customerSignComplete,
            InitialPaymentComplete:
              agreementDetailsContext.popupCompleted.initialPaymentComplete,
          });
          setLoaderEnabled(false);
          setNextBtnDisabled(false);
          setAutoPayToggleStatus(
            agreementDetailsContext.generalInformation.isAutopayEnabled
          );
        } else {
          setSomethingWentWrong(true);
        }
      };
      AgreementInfoLoad();
    } else {
      setSomethingWentWrong(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (
      CreateVehicleInputs.Make !== '' &&
      CreateVehicleInputs.Model !== '' &&
      CreateVehicleInputs.VIN !== '' &&
      CreateVehicleInputs.Year !== '' &&
      CreateVehicleInputs.VehicleLicensePlate !== ''
    ) {
      setCreateVehicleControls({
        ...CreateVehicleControls,
        CreateVehicleSubmit: false,
      });
    }
    if (
      CreateVehicleInputs.Make === '' ||
      CreateVehicleInputs.Model === '' ||
      CreateVehicleInputs.VIN === '' ||
      CreateVehicleInputs.Year === '' ||
      CreateVehicleInputs.VehicleLicensePlate === ''
    ) {
      setCreateVehicleControls({
        ...CreateVehicleControls,
        CreateVehicleSubmit: true,
      });
    }
    if (VehcileInfoChxboxState.includes(true)) {
      setVehicleInfoInput({ ...VehicleInfoInput, SubmitDisabled: false });
    }
    if (VehcileInfoChxboxState.includes(true) === false) {
      setVehicleInfoInput({ ...VehicleInfoInput, SubmitDisabled: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CreateVehicleInputs, VehcileInfoChxboxState]);
  useEffect(() => {
    const GettingRole = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log('GetcurrentUser', GetcurrentUser);
      if (GetcurrentUser.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        const GetMenuPayload = {
          coworkerId: EmployeeId,
        };
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        console.log('GetMenuDetails', GetMenuDetails);
        if (GetMenuDetails.status === 200) {
          const GetMenuDetailsResponse = GetMenuDetails.data;
          const currentRole = GetMenuDetailsResponse.coworkerProfile.role;
          console.log('currentRole', currentRole);
          setCurrentRole(currentRole);
        }
      }
    };
    if (containerData !== undefined) {
      console.log('containerData', containerData);
      console.log('containerDataRole', containerData.GetRole());
      setCurrentRole(containerData.GetRole());
    } else {
      GettingRole();
    }
  }, []);

  useEffect(() => {
    if (
      AgreementId !== undefined &&
      AgreementId !== null &&
      AgreementId !== ''
    ) {
      setVoidEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AgreementId]);

  function getActivePhoneNumber(phoneNumbers: any) {
    for (const phoneNumber of phoneNumbers) {
      switch (phoneNumber.phoneType) {
        case 'CELL':
          return phoneNumber.PhoneNumber;
        case 'HOME':
          return phoneNumber.PhoneNumber;
        case 'REF':
          return phoneNumber.PhoneNumber;
        case 'WORK':
          return phoneNumber.PhoneNumber;
        default:
          return phoneNumber.PhoneNumber

      }
    }
    return undefined;
  }
  const ConvertDueDate = (RawDate: any) => {
    let DueDate = '';
    if (RawDate[0] === '01') {
      DueDate = t('Jan') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '02') {
      DueDate = t('Feb') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '03') {
      DueDate = t('Mar') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '04') {
      DueDate = t('Apr') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '05') {
      DueDate = t('May') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '06') {
      DueDate = t('Jun') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '07') {
      DueDate = t('Jul') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '08') {
      DueDate = t('Aug') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '09') {
      DueDate = t('Sep') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '10') {
      DueDate = t('Oct') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '11') {
      DueDate = t('Nov') + ' ' + RawDate[1] + ', ' + RawDate[2];
    } else if (RawDate[0] === '12') {
      DueDate = t('Dec') + ' ' + RawDate[1] + ', ' + RawDate[2];
    }
    return DueDate;
  };
  //PS_AD-6 In NextBtnClick based upon the popup completion status popup will be displayed
  const NextBtnClick = async () => {
    try {
      setNextBtnClicked(true);

      if (
        TireAgreement === true &&
        PopupCompleteStatus.ConfirmDueDateComplete === false
      ) {
        const TempCreateAgrReq: any = CreateAgrReqObj;
        setHiddenLoader(true);
        const GetCustomerResponse = await GetCustomer(CustomerID, StoreNumber);
        if (GetCustomerResponse.status === 200) {
          const GetCustomerResponseBind = GetCustomerResponse.data;
          const CustomerVehicles =
            GetCustomerResponseBind.GetCustomer.value.vehicles;
          if (CustomerVehicles !== undefined) {
            console.log('CustomerVehicles', CustomerVehicles);
            const CustomerVehiclesSort = CustomerVehicles.sort(function (a, b) {
              return (
                parseInt(b.customerVehicleId) - parseInt(a.customerVehicleId)
              );
            });
            console.log('CustomerVehiclesSort', CustomerVehiclesSort);
            setVehicleDetailsArray(CustomerVehiclesSort);
            if (CustomerVehiclesSort !== undefined) {
              const FalseArray: any = new Array(
                CustomerVehiclesSort.length
              ).fill(false);
              FalseArray[0] = true;
              TempCreateAgrReq.agreementInfo.vehicleId = parseInt(
                CustomerVehiclesSort[0].customerVehicleId
              );
              setCreateAgrReqObj(TempCreateAgrReq);
              setVehcileInfoChxboxState(FalseArray);
            }
            setHiddenLoader(false);
          } else if (CustomerVehicles === undefined) {
            setHiddenLoader(false);
          }
        }

        setPopupOpen({ ...PopupOpen, VehicleInfoOpen: true });
      } else if (
        PopupCompleteStatus.ConfirmDueDateComplete === false &&
        TireAgreement === false
      ) {
        setPopupOpen({ ...PopupOpen, ConfirmDueDateOpen: true });
      } else if (
        PopupCompleteStatus.ConfirmDueDateComplete === true &&
        PopupCompleteStatus.AutoPayComplete === false
      ) {
        setPopupOpen({ ...PopupOpen, AutoPayOpen: true });
      } else if (
        PopupCompleteStatus.AutoPayComplete === true &&
        PopupCompleteStatus.CustomerSignComplete === false &&
        PopupCompleteStatus.InitialPaymentComplete === false
      ) {
        setPopupOpen({ ...PopupOpen, CustomerSignOpen: true });
      } else if (
        PopupCompleteStatus.CustomerSignComplete === true &&
        PopupCompleteStatus.InitialPaymentComplete === false
      ) {
        setPopupOpen({ ...PopupOpen, InitialPaymentOpen: true });
      } else if (PopupCompleteStatus.InitialPaymentComplete === true) {
        history.push({
          pathname: `/agreement/rental/delivery/${CustomerID}/${AgreementId}`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      }
    } catch {
      throw Error;
    }
  };
  const VehicleDetailsBind = () => {
    if (VehicleDetailsArray !== undefined) {
      return VehicleDetailsArray.map((value: any, index: any) => {
        return (
          <tr key={index}>
            <td>
              {VehicleInfoInput.ChkBoxIndex === index ? (
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  checked={VehicleInfoInput.VehicleChkBox}
                  onChange={() => SelectVehicle(index)}
                />
              ) : (
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  checked={false}
                  onChange={() => SelectVehicle(index)}
                />
              )}
            </td>
            <td>
              <a className="racpad-link" href="#">
                {value.vehicleMake}
              </a>
            </td>
            <td>{value.vehicleModel}</td>
            <td>{value.vehicleYear}</td>
            <td>{value.vehicleVin}</td>
          </tr>
        );
      });
    }
  };
  const SelectVehicle = (index: any) => {
    try {
      setVehicleInfoInput({
        ...VehicleInfoInput,
        SubmitDisabled: false,
        VehicleChkBox: true,
        ChkBoxIndex: index,
      });
    } catch {
      throw Error;
    }
  };
  const VehicleInfoSubmitClick = () => {
    try {
      setPopupCompleteStatus({
        ...PopupCompleteStatus,
        VehicleInfoComplete: true,
      });
      setPopupOpen({
        ...PopupOpen,
        VehicleInfoOpen: false,
        ConfirmDueDateOpen: true,
      });
    } catch {
      throw Error;
    }
  };
  const CreateVehicleClick = () => {
    try {
      setPopupOpen({
        ...PopupOpen,
        VehicleInfoOpen: false,
        CreateVehicleOpen: true,
      });
    } catch {
      throw Error;
    }
  };
  const CreateVehicleCancelClick = () => {
    try {
      setCreateVehicleInputs({
        ...CreateVehicleInputs,
        Make: '',
        Model: '',
        Year: '',
        VIN: '',
        VehicleLicensePlate: '',
      });
      setPopupOpen({
        ...PopupOpen,
        VehicleInfoOpen: true,
        CreateVehicleOpen: false,
      });
    } catch {
      throw Error;
    }
  };
  const CreateVehicleSubmitClick = async () => {
    try {
      debugger;
      const TempCreateAgrReq = CreateAgrReqObj;
      setHiddenLoader(true);
      const TempArr: any = [];
      if (VehicleDetailsArray !== undefined) {
        for (let i = 0; i <= VehicleDetailsArray.length - 1; i++) {
          const obj = {
            customerVehicleId: null,
            vehicleIndex: null,
            vehicleVin: VehicleDetailsArray[i].vehicleVin,
            vehicleMake: VehicleDetailsArray[i].vehicleMake,
            vehicleModel: VehicleDetailsArray[i].vehicleModel,
            vehicleYear: VehicleDetailsArray[i].vehicleYear,
            vehicleLicensePlate: VehicleDetailsArray[i].vehicleLicensePlate,
            vehPlanExpirationDate: null,
            vehFinancedFrom: null,
            vehMonthlyPayment: null,
            vehRegState: null,
            vehicleTagNumber: null,
          };
          TempArr.push(obj);
        }
      }

      const tempobj = {
        customerVehicleId: null,
        vehicleIndex: null,
        vehicleVin: CreateVehicleInputs.VIN,
        vehicleMake: CreateVehicleInputs.Make,
        vehicleModel: CreateVehicleInputs.Model,
        vehicleYear: CreateVehicleInputs.Year,
        vehicleLicensePlate: CreateVehicleInputs.VehicleLicensePlate,
        vehPlanExpirationDate: null,
        vehFinancedFrom: null,
        vehMonthlyPayment: null,
        vehRegState: null,
        vehicleTagNumber: null,
      };
      TempArr.push(tempobj);
      const UpdateVehiclePayload = {
        customerId: CustomerID,
        globalCustomerId: GlobalCustomerID,
        vehicles: TempArr,
      };
      console.log('UpdateVehiclePayload', UpdateVehiclePayload);
      const UpdateVehicleInfoResponse: any = await UpdateVehicleInfo(
        CustomerID,
        UpdateVehiclePayload
      );
      console.log('UpdateVehicleInfoResponse', UpdateVehicleInfoResponse);

      if (UpdateVehicleInfoResponse.status === 200) {
        const GetCustomerResponse = await GetCustomer(CustomerID, StoreNumber);
        console.log('GetCustomerResponse', GetCustomerResponse);
        setHiddenLoader(false);
        if (GetCustomerResponse.status === 200) {
          const GetCustomerData = GetCustomerResponse.data;
          const ReGeneratedVehciles =
            GetCustomerData.GetCustomer.value.vehicles;
          const ReGeneratedVehcilesSort = ReGeneratedVehciles.sort(function (
            a,
            b
          ) {
            return (
              parseInt(b.customerVehicleId) - parseInt(a.customerVehicleId)
            );
          });
          const FalseArray: any = new Array(
            GetCustomerData.GetCustomer.value.vehicles.length
          ).fill(false);
          FalseArray[0] = true;
          setVehcileInfoChxboxState(FalseArray);
          TempCreateAgrReq.agreementInfo.vehicleId = parseInt(
            ReGeneratedVehcilesSort[0].customerVehicleId
          );
          setVehicleDetailsArray(ReGeneratedVehcilesSort);
          setCreateAgrReqObj(TempCreateAgrReq);
        }
        setPopupOpen({
          ...PopupOpen,
          CreateVehicleOpen: false,
          VehicleInfoOpen: true,
        });
        setCreateVehicleInputs({
          ...CreateVehicleInputs,
          Make: '',
          Model: '',
          Year: '',
          VIN: '',
          VehicleLicensePlate: '',
        });
      }
    } catch {
      throw Error;
    }
  };
  const CreateVehicleYearOnchange = (e) => {
    const value = e.target.value;
    setCreateVehicleInputs({ ...CreateVehicleInputs, Year: value });
  };

  const CreateVehicleInputOnchange = (e: any) => {
    try {
      const FieldName = e.target.name;
      const FieldValue = e.target.value;
      if (FieldName === 'Make') {
        setCreateVehicleInputs({ ...CreateVehicleInputs, Make: FieldValue });
      } else if (FieldName === 'Model') {
        setCreateVehicleInputs({ ...CreateVehicleInputs, Model: FieldValue });
      } else if (FieldName === 'Year') {
        setCreateVehicleInputs({ ...CreateVehicleInputs, Year: FieldValue });
      } else if (FieldName === 'VIN') {
        setCreateVehicleInputs({ ...CreateVehicleInputs, VIN: FieldValue });
      } else if (FieldName === 'VehicleLicensePlate') {
        setCreateVehicleInputs({
          ...CreateVehicleInputs,
          VehicleLicensePlate: FieldValue,
        });
      }
    } catch {
      throw Error;
    }
  };
  //Confirm date popup actions handle if autopay not enabled before showing autopay popup here
  const ConfirmDueDateAction = async () => {
    try {
      props.setAgrDetailsCompleted(true);
      setPopupOpen({ ...PopupOpen, ConfirmDueDateOpen: false });
      setCreateAgrProcessingPopup(true);
      const CustomerArray = ItemSearchData.customer;
      if (
        CustomerInfoContext[0].CoCustomerId !== undefined &&
        CustomerInfoContext[0].CoCustomerId !== null &&
        CustomerInfoContext[0].CoCustomerId !== '' &&
        CustomerArray.length < 2
      ) {
        const obj = {
          customerId: parseFloat(CustomerInfoContext[0].CoCustomerId),
          priority: 2,
        };
        CustomerArray.push(obj);
      }
      CreateAgrReqObj.customer = CustomerArray;
      CreateAgrReqObj.agreementInfo.deDecisionId = Number(CustomerInfoContext[0].deDecisionId);
      console.log('exact Create agreement response -->', CreateAgrReqObj);
      const CreateAgreementApiRes = await CreateAgreement(CreateAgrReqObj);
      debugger;
      console.log('Create agreement response -->', CreateAgreementApiRes);
      const CreateAgreementResponse = CreateAgreementApiRes.data;
      if (CreateAgreementApiRes.status === 200) {
        setreinstateDone(true);
        setCreateAgrProcessingMessage(
          'We are generating the agreement documents for you!'
        );
        setagreementCreateStatus({ agreementCreatedStatus: true });
        props.setAgrDetailsCompleted(true);
        setAgreementId(CreateAgreementResponse.agreementId.toString());
        props.setWizardAgrId(CreateAgreementResponse.agreementId.toString());
        console.log('Agreement create final req', CreateAgrReqObj);
        setEditDisablemode(true);
        setPopupCompleteStatus({
          ...PopupCompleteStatus,
          ConfirmDueDateComplete: true,
        });

        const AgreementCustomers = CreateAgreementResponse.customers;
        const Customerdata = AgreementCustomers.filter(
          (obj) => obj.priority === 1
        );
        const CustomerName =
          Customerdata[0].firstName + ' ' + Customerdata[0].lastName;
        const TempPrimaryCusInfo = {
          customerId: Customerdata[0].customerId.toString(),
          phoneNumber: Customerdata[0]?.phoneNumbers ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) : Customerdata[0]?.phoneNumber : Customerdata[0]?.phoneNumber, emailAddress: Customerdata[0].emailAddress,
          customerName: CustomerName,
        };
        setPrimaryCustomerInfo(TempPrimaryCusInfo);
        if (AgreementCustomers.length === 1) {
          const AGreementDocObj: any = GenerateDocReq;
          setCustomerSign({
            ...CustomerSign,
            CustomerName: CustomerName,
            CustomerPhoneNumber: Customerdata[0].phoneNumber,
            CustomerEmail: Customerdata[0].emailAddress,
            PresentToSign: 'Customer',
          });
          console.log('SetStateCompleted');
          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber: Customerdata[0].phoneNumber,
              emailId: Customerdata[0].emailAddress,
              priority: 1,
            },
          ];
          console.log('PayloadForm');
          setAgrCustomerObj(CustomerObj);
          AGreementDocObj.signers = CustomerObj;
          setGenerateDocReq(AGreementDocObj);
        } else {
          const AGreementDocObj: any = GenerateDocReq;
          const CoCustomer = AgreementCustomers.filter(
            (obj) => obj.priority === 2
          );
          const CoCustomerName =
            CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;
          setCustomerSign({
            ...CustomerSign,
            CustomerName: CustomerName,
            CustomerPhoneNumber: Customerdata[0].phoneNumber,
            CustomerEmail: Customerdata[0].emailAddress,
            CoCustomerName: CoCustomerName,
            CoCustomerPhoneNumber: CoCustomer[0].phoneNumber,
            CoCustomerEmail: CoCustomer[0].emailAddress,
            PresentToSign: BothCustomer,
            BothCustomerSelected: true,
          });
          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber: Customerdata[0]?.phoneNumbers ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) : Customerdata[0]?.phoneNumber : Customerdata[0]?.phoneNumber,
              emailId: Customerdata[0].emailAddress,
              priority: 1,
            },
            {
              customerId: CoCustomer[0].customerId.toString(),
              customerName: CoCustomerName,
              phoneNumber: CoCustomer[0]?.phoneNumbers ? getActivePhoneNumber(CoCustomer[0]?.phoneNumbers) ? getActivePhoneNumber(CoCustomer[0]?.phoneNumbers) : CoCustomer[0]?.phoneNumber : CoCustomer[0]?.phoneNumber,
              emailId: CoCustomer[0].emailAddress,
              priority: 2,
            },
          ];
          setAgrCustomerObj(CustomerObj);
          AGreementDocObj.signers = CustomerObj;
          setGenerateDocReq(AGreementDocObj);
        }
        if (PopupCompleteStatus.AutoPayComplete === true) {
          const AutopayReq: any = SendAutopayTextReq;
          const AgrId = [parseInt(CreateAgreementResponse.agreementId)];
          AutopayReq.agreementIds = AgrId;
          console.log('SendTexttopay req', AutopayReq);
          const SendAutopayTextResponse = await SendAutopayText(AutopayReq);
          console.log(
            'Update autopay response in confirm-->',
            SendAutopayTextResponse
          );
        }
        const AgreementDocReq: any = GenerateDocReq;
        AgreementDocReq.identifier = CreateAgreementResponse.agreementId;
        AgreementDocReq.identifierType = 'AGR';
        AgreementDocReq.signatureType = 1;
        AgreementDocReq.isRemote = false;
        AgreementDocReq.manualSignatureReasonId = null;
        if (AgreementCustomers.length === 1) {
          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber:
                Customerdata[0].phoneNumber !== null
                  ? Customerdata[0].phoneNumber
                  : '1111111111',
              emailId:
                Customerdata[0].emailAddress !== null
                  ? Customerdata[0].emailAddress
                  : 'test@example.com',
              priority: 1,
            },
          ];
          AgreementDocReq.signers = CustomerObj;
        } else {
          const CoCustomer = AgreementCustomers.filter(
            (obj) => obj.priority === 2
          );
          const CoCustomerName =
            CoCustomer[0].firstName + CoCustomer[0].lastName;

          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber:
                Customerdata[0].phoneNumber !== null
                  ? Customerdata[0].phoneNumber
                  : '1111111111',
              emailId:
                Customerdata[0].emailAddress !== null
                  ? Customerdata[0].emailAddress
                  : 'test@example.com',
              priority: 1,
            },
            {
              customerId: CoCustomer[0].customerId.toString(),
              customerName: CoCustomerName,
              phoneNumber:
                CoCustomer[0].phoneNumber !== null
                  ? CoCustomer[0].phoneNumber
                  : '1111111111',
              emailId:
                CoCustomer[0].emailAddress !== null
                  ? CoCustomer[0].emailAddress
                  : 'test@example.com',
              priority: 2,
            },
          ];
          AgreementDocReq.signers = CustomerObj;
        }
        console.log('AgreementDocReq in create agr', AgreementDocReq);
        setCreateAgrProcessingPopup(false);
        if (AutoPayToggleStatus !== true) {
          setPopupOpen({
            ...PopupOpen,
            ConfirmDueDateOpen: false,
            AutoPayOpen: true,
          });
        } else {
          setPopupOpen({
            ...PopupOpen,
            ConfirmDueDateOpen: false,
            CustomerSignOpen: true,
          });
        }
        const GenerateAgreementDocRes = await GenerateAgreementDoc(
          AgreementDocReq
        );
        console.log(
          'First Generate Agreement Call response',
          GenerateAgreementDocRes
        );
        setdocumentGenerateCompleted(true);
      } else if (CreateAgreementApiRes.status === 400) {
        const ErrorArray = CreateAgreementApiRes.data.errors;
        const CheckErrorArray = ErrorArray.filter(
          (obj: any) => obj.error == 'Inventory is not in rent ready status'
        );
        
        if (CheckErrorArray.length > 0) {
          setCreateAgrFirstFailMessage('Sorry!');
          setCreateAgrFailMessage('The inventory is already rented');
        }
        setCreateAgrProcessingPopup(false);
        setCreateAgrFailPopup(true);
      } else {
        setCreateAgrFirstFailMessage('Oops!!');
        setCreateAgrFailMessage(t('Unable to create agreement at this moment'));
        setCreateAgrProcessingPopup(false);
        setCreateAgrFailPopup(true);
      }
    } catch {
      throw Error;
    }
  };
  const AutopayChkboxAction = () => {
    try {
      if (AutopayInput.AutopayChkBox === false) {
        setAutoPayInput({
          ...AutopayInput,
          AutopayChkBox: true,
          AutoPaySubmitDisable: false,
        });
      } else {
        setAutoPayInput({
          ...AutopayInput,
          AutopayChkBox: false,
          AutoPaySubmitDisable: true,
        });
      }
    } catch {
      throw Error;
    }
  };
  //AutoPayCloseClick function close the autopay popup and set the AutoPayToggleStatus into false
  const AutoPayCloseClick = () => {
    try {
      setPopupOpen({ ...PopupOpen, AutoPayOpen: false });
      setAutoPayInput({
        ...AutopayInput,
        AutopayChkBox: false,
        AutoPaySubmitDisable: true,
      });

      setAutoPayToggleStatus(false);
    } catch {
      throw Error;
    }
  };
  //AutoPayCloseClick close the autopay popup and reset the autopay input fields into default status
  const AutoPayNotnowClick = async () => {
    try {
      if (NextBtnClicked === false) {
        setPopupOpen({ ...PopupOpen, AutoPayOpen: false });
        setAutoPayInput({
          ...AutopayInput,
          AutopayChkBox: false,
          AutoPaySubmitDisable: true,
        });

        setAutoPayToggleStatus(false);
      } else {
        setAutoPayInput({
          ...AutopayInput,
          AutopayChkBox: false,
          AutoPaySubmitDisable: true,
        });
        setAutoPayToggleStatus(false);
        setPopupOpen({
          ...PopupOpen,
          AutoPayOpen: false,
          CustomerSignOpen: true,
        });
        setPopupCompleteStatus({
          ...PopupCompleteStatus,
          AutoPayComplete: true,
        });
      }
    } catch {
      throw Error;
    }
  };
  //AutoPaySubmitClick calling the Api to update the auto active and set the input into default status and set the popup complete status
  const AutoPaySubmitClick = () => {
    try {
      setPopupOpen({ ...PopupOpen, AutoPayOpen: false });
      setAutoPayInput({
        ...AutopayInput,
        AutopayChkBox: false,
        AutoPaySubmitDisable: true,
      });
      setAutoPayToggleStatus(true);

      setPopupCompleteStatus({ ...PopupCompleteStatus, AutoPayComplete: true });
      if (PopupCompleteStatus.ConfirmDueDateComplete === true) {
        const AutopayReq: any = SendAutopayTextReq;
        const AgrId = [parseInt(AgreementId)];
        AutopayReq.agreementIds = AgrId;
        console.log('Sendtextto request', AutopayReq);
        console.log('Autopay Req--->', AutopayReq);
        const UpdateAutopayResponse = SendAutopayText(AutopayReq);
        setPopupOpen({
          ...PopupOpen,
          AutoPayOpen: false,
          CustomerSignOpen: true,
        });
        console.log('Autopay response--->', UpdateAutopayResponse);
      } else if (PopupCompleteStatus.ConfirmDueDateComplete === false) {
        setPopupOpen({
          ...PopupOpen,
          AutoPayOpen: false,
        });
      }
    } catch {
      throw Error;
    }
  };

  const InitialPaymentCloseClick = () => {
    try {
      setPopupOpen({
        ...PopupOpen,
        InitialPaymentOpen: false,
      });
    } catch {
      throw Error;
    }
  };
  const Openlogin = (loginstate: any) => {
    try {
      if (loginstate === 'activated') {
        setPopupOpen({ ...PopupOpen, LoginOpen: true });
      }
    } catch {
      throw Error;
    }
  };

  const GeneralInfoInputsChanged = (RequestObj: any) => {
    const CreateAgreementReqObj: any = CreateAgrReqObj;
    CreateAgreementReqObj.agreementInfo.salesPersonId =
      RequestObj.SalespersonId !== undefined
        ? RequestObj.SalespersonId?.toString()
        : CreateAgreementReqObj.agreementInfo.salesPersonId?.toString();
    CreateAgreementReqObj.agreementInfo.agreementSource =
      RequestObj.AgreementSourceId !== undefined
        ? RequestObj.AgreementSourceId
        : CreateAgreementReqObj.agreementInfo.agreementSource;
    setCreateAgrReqObj(CreateAgreementReqObj);
  };
  const SacChanged = (RequestObj: any) => {
    console.log('changed sac amount', RequestObj);
    const CreateAgreementReqObj: any = CreateAgrReqObj;
    CreateAgreementReqObj.agreementInfo.sacPrice =
      RequestObj.sacPrice !== undefined
        ? RequestObj.sacPrice
        : CreateAgreementReqObj.agreementInfo.sacPrice;
    setCreateAgrReqObj(CreateAgreementReqObj);
  };
  const OtherAmtChanged = (RequestObj: any) => {
    console.log('changed other amount', RequestObj);
    const CreateAgreementReqObj: any = CreateAgrReqObj;
    CreateAgreementReqObj.fees =
      RequestObj !== undefined ? RequestObj : CreateAgreementReqObj.fees;
    setCreateAgrReqObj(CreateAgreementReqObj);
  };
  const DropdownReset = () => {
    childCompRef.current.DropdownReset();
  };
  // eslint-disable-next-line sonarjs/cognitive-complexity
  const RecalculateClicked = async (RequestObj: any) => {
    setEditDisablemode(true);
    setDeliveryChargeDisable(true);
    setPaymentCostLoading(true);
    console.log('Recalculate obj from child component', RequestObj);
    console.log('Recalculate obj in parent component', GetPriceQuoteRequest);
    const RecalculateReqObj: any = GetPriceQuoteRequest;
    const CreateAgreementReqObj: any = CreateAgrReqObj;
    let fees: any = RecalculateReqObj.fees;
    // eslint-disable-next-line no-console
    RecalculateReqObj.deliveryCharge =
      RequestObj.DeliveryCharge !== undefined
        ? RequestObj.DeliveryCharge
        : RecalculateReqObj.deliveryCharge;

    //checking delivery fee undefined check
    if (RequestObj.DeliveryCharge != undefined) {
      //checking deivery fee already present in request
      if (fees.filter((e) => e.feeType == 'DELI').length > 0) {
        //checking delivery fee has no value
        if (
          RequestObj.DeliveryCharge == '' ||
          RequestObj.DeliveryCharge == '0.00'
        ) {
          fees = fees.filter((e) => e.feeType != 'DELI');
        }
        //if delivery fee has any value and already present in request
        else {
          const indexOfDuplicate = fees.findIndex(
            (arr) => arr.feeType === 'DELI'
          );
          fees[indexOfDuplicate] = {
            feeType: 'DELI',
            feeAmount: RequestObj.DeliveryCharge,
          };
        }
      }
      //if delivery fee is not present in request
      else {
        if (
          RequestObj.DeliveryCharge != '' &&
          RequestObj.DeliveryCharge != '0.00'
        ) {
          fees.push({
            feeType: 'DELI',
            feeAmount: RequestObj.DeliveryCharge,
          });
        }
      }
    }
    RecalculateReqObj.fees = fees;
    RecalculateReqObj.dueDate =
      RequestObj.Duedate !== undefined
        ? RequestObj.Duedate
        : RecalculateReqObj.dueDate;
    RecalculateReqObj.extensionDays =
      RequestObj.ExtensionDays !== undefined
        ? RequestObj.ExtensionDays
        : RecalculateReqObj.extensionDays;
    RecalculateReqObj.schedule =
      RequestObj.Schedule !== undefined
        ? RequestObj.Schedule
        : RecalculateReqObj.schedule;
    RecalculateReqObj.isLDWapplied =
      RequestObj.optionalservice !== undefined
        ? RequestObj.optionalservice.isLDWapplied
        : RecalculateReqObj.isLDWapplied;
    RecalculateReqObj.isClubApplied =
      RequestObj.optionalservice !== undefined
        ? RequestObj.optionalservice.isClubApplied
        : RecalculateReqObj.isClubApplied;
    RecalculateReqObj.range =
      RequestObj.range !== undefined
        ? RequestObj.range
        : RecalculateReqObj.range;
    RecalculateReqObj.tireplusPolicy =
      RequestObj.PolicyApplied !== undefined
        ? RequestObj.PolicyApplied
        : RecalculateReqObj.tireplusPolicy;
    RequestObj.isLDWWaived != undefined
      ? ((RecalculateReqObj.isLDWWaived = RequestObj.isLDWWaived),
        (CreateAgreementReqObj.coverages.isLDWWaived = RequestObj.isLDWWaived))
      : null;
    CreateAgreementReqObj.agreementInfo.schedule =
      RequestObj.Schedule !== undefined
        ? RequestObj.Schedule
        : CreateAgreementReqObj.agreementInfo.schedule;
    CreateAgreementReqObj.agreementInfo.salesPersonId =
      RequestObj.SalespersonId !== undefined
        ? RequestObj.SalespersonId?.toString()
        : CreateAgreementReqObj.agreementInfo.salesPersonId?.toString();
    CreateAgreementReqObj.agreementInfo.extensionDays =
      RequestObj.ExtensionDays !== undefined
        ? RequestObj.ExtensionDays
        : CreateAgreementReqObj.agreementInfo.extensionDays;
    CreateAgreementReqObj.agreementInfo.agreementSource =
      RequestObj.AgreementSourceId !== undefined
        ? RequestObj.AgreementSourceId
        : CreateAgreementReqObj.agreementInfo.agreementSource;
    CreateAgreementReqObj.agreementInfo.duedate =
      RequestObj.Duedate !== undefined
        ? RequestObj.Duedate
        : CreateAgreementReqObj.agreementInfo.duedate;
    CreateAgreementReqObj.agreementInfo.range =
      RequestObj.range !== undefined
        ? RequestObj.range
        : CreateAgreementReqObj.agreementInfo.range;
    if (RequestObj.optionalservice !== undefined) {
      CreateAgreementReqObj.coverages.isLdwApplied =
        RequestObj.optionalservice.isLDWapplied !== undefined
          ? RequestObj.optionalservice.isLDWapplied
          : CreateAgreementReqObj.coverages.isLdwApplied;
      CreateAgreementReqObj.coverages.isClubApplied =
        RequestObj.optionalservice.isClubApplied !== undefined
          ? RequestObj.optionalservice.isClubApplied
          : CreateAgreementReqObj.coverages.isClubApplied;
    }
    CreateAgreementReqObj.coverages.isTirepolicyApplied =
      RequestObj.PolicyApplied !== undefined
        ? RequestObj.PolicyApplied
        : CreateAgreementReqObj.coverages.isTirepolicyApplied;
    console.log(
      'Create agreement modified after recalculate',
      CreateAgreementReqObj
    );

    console.log(
      'Recalculate obj in recalculate btn click-->',
      RecalculateReqObj
    );
    const GetPriceQuoteRes = await getPriceQuote(RecalculateReqObj);
    setEditDisablemode(false);
    console.log('Recaculate getprice quote raw response', GetPriceQuoteRes);
    if (GetPriceQuoteRes !== undefined && GetPriceQuoteRes.status === 200) {
      /* eslint-disable no-console */
      setLoaderEnabled(false);
      setPaymentCostLoading(false);
      console.log(
        'GetPriceQuoteResponse inside setState----->',
        GetPriceQuoteRes
      );
      if (RequestObj.PolicyApplied !== undefined) {
        if (RequestObj.PolicyApplied === true) {
          setTireAgreement(true);
        } else if (RequestObj.PolicyApplied === false) {
          setTireAgreement(false);
        }
      }
      const GetPriceQuoteData = GetPriceQuoteRes.data;
      const PaymentScheduleVal = GetPriceQuoteData.paymentSchedule;
      const InitialPaymentVal = GetPriceQuoteData.agreementInitialPayment;
      const TotalPaymentVal = GetPriceQuoteData.agreementTotalPayment;
      const RawDueDate = GetPriceQuoteData.agreementSchedule.dueDate;
      const FeesArr = GetPriceQuoteData.fees;
      const ConvFeesArr = FeesArr.map((ele: any) => {
        return { feeAmount: parseFloat(ele.feeAmount), feeType: ele.feeType };
      });
      CreateAgreementReqObj.agreementInfo.schedule =
        GetPriceQuoteData.agreementSchedule.schedule;
      CreateAgreementReqObj.fees = ConvFeesArr;
      const RawDueDateArray = RawDueDate.split('/');
      const FormatedDuedate =
        RawDueDateArray[2] +
        '-' +
        RawDueDateArray[0] +
        '-' +
        RawDueDateArray[1];
      setOtherFeeArray(ConvFeesArr);
      setCalenderDuedate(FormatedDuedate);
      setPaymentScheduleValues(PaymentScheduleVal);
      setInitialPaymentValues(InitialPaymentVal);
      setTotalPaymentValues(TotalPaymentVal);
      setAgreementSchedule(GetPriceQuoteData.agreementSchedule);
      console.log(
        'Agreement schedule after drop down ',
        GetPriceQuoteData.agreementSchedule
      );
      const RawDueDateArr = RawDueDate.split('/');
      console.log('DueDateArray--->', RawDueDateArr);
      const NxtDueDate = ConvertDueDate(RawDueDateArr);
      setNextDueDate(NxtDueDate);
      setPayScheduleValues(GetPriceQuoteData.paymentSchedule);
    } else if (GetPriceQuoteRes.status === 400) {
      setPaymentCostLoading(false);
      const ErrorMessage = GetPriceQuoteRes.data.errors[0].error;
      setCreateAgrFirstFailMessage(ErrorMessage);
      setCreateAgrFailMessage('Please update and try again');
      setCreateAgrFailPopup(true);
      setEditDisablemode(false);
      DropdownReset();
    } else {
      setPaymentCostLoading(false);
      setSomethingWentWrongOpen(true);
      setEditDisablemode(false);
      DropdownReset();
    }
    console.log(
      'Create Agreement Obj after recalculate click',
      CreateAgreementReqObj
    );
    setCreateAgrReqObj(CreateAgreementReqObj);
  };
  const PreviousBtnClick = () => {
    console.log('Previous btn clicked');
    const origin = new URLSearchParams(searchAM).get('origin');
    if (origin === 'am-customer') {
      history.push({
        pathname: `${AppRoute.AMCustomer}/${CustomerID}`,
      });
      return;
    }
    if (AgreementId === '' && origin !== 'am-customer') {
      history.push({
        pathname: `/agreement/reinstate/itemsearch/${CustomerID}?coCustomerId=N`,
      });
    } else if (
      AgreementId !== '' &&
      origin !== 'am-customer' &&
      transferrightsapplied != undefined
    ) {
      history.push({
        pathname: `/agreement/reinstate/itemsearch/${CustomerID}/${AgreementId}?coCustomerId=N&transferrightsapplied=Y`,
      });
    } else if (AgreementId !== '' && origin !== 'am-customer') {
      history.push({
        pathname: `/agreement/reinstate/itemsearch/${CustomerID}/${AgreementId}?coCustomerId=N`,
      });
    }

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent('popstate');
    window.dispatchEvent(navEvent);
  };
  const InitialPaymentOnclick = () => {
    history.push({
      pathname: `/payment1/paymentinformation/${CustomerID}/${AgreementId}`,
    });
  };
  const InitialPaymentNoBtnclick = () => {
    setPopupOpen({ ...PopupOpen, InitialPaymentOpen: false });
  };
  const HideLoader = () => {
    return (
      <Grid
        style={{
          position: 'fixed',
          background: '#f7f5f5',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          opacity: 0.6,
          zIndex: 2000,
          textAlign: 'center',
          margin: '0px 0px',
        }}
      >
        <Grid
          style={{
            display: 'block',
            position: 'fixed',
            zIndex: 9999999,
            top: '40%',
            right: '50%',
          }}
        >
          <CircularProgress />
        </Grid>
      </Grid>
    );
  };
  const CreateAgreementProcessingPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography className={classes.formLabel}>{t("Please wait...")}</Typography>
          <Typography className={classes.formLabel}>
            {t(CreateAgrProcessingMessage)}
          </Typography>
          <CircularProgress style={{ marginTop: '30px' }} size={25} />
        </Grid>
      </div>
    );
  };
  const CreateAgreementFailPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography className={classes.formLabel}>
            {t(CreateAgrFirstFailMessage)}
          </Typography>
          <Typography className={classes.formLabel}>
            {' '}
            {t(CreateAgrFailMessage)}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => setCreateAgrFailPopup(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const SomethingWentWrongPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Alerticon></Alerticon>

          <Typography className={classes.formLabel}>
            {t("Something went wrong!")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => setSomethingWentWrongOpen(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const ErrorMsgPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Alerticon></Alerticon>
          <Typography className={`${classes.formLabel} ${classes.m16px}`}>{ApiErrorMsg}</Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              history.push({
                pathname: `/dashboard`,
              });
            }}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const ManualSignOptions = [
    {
      value: '',
      label: t('Select'),
    },
    {
      value: '3',
      label: t('Technology issue - Digital Signing'),
    },
    {
      value: '2',
      label: t('Technology issue - Customer'),
    },
    {
      value: '1',
      label: t('Customer requires Paper Signature'),
    },
  ];

  const VehicleHeadArr = [
    {
      displayName: '',
    },
    {
      displayName: 'Make',
    },
    {
      displayName: 'Model',
    },
    {
      displayName: 'Year',
    },
    {
      displayName: 'Vin#',
    },
  ];
  const VehicleInfoChxboxOnchnage = (index: any) => {
    console.log('VehicleInfoChxboxOnchnage', index);
    const TempCreateAgrReq = CreateAgrReqObj;
    const TempChkboxArr: any = new Array(VehcileInfoChxboxState.length).fill(
      false
    );
    TempChkboxArr[index] = true;
    setVehcileInfoChxboxState(TempChkboxArr);
    TempCreateAgrReq.agreementInfo.vehicleId = parseInt(
      VehicleDetailsArray[index].customerVehicleId
    );
    setCreateAgrReqObj(TempCreateAgrReq);
    setVehicleInfoInput({ ...VehicleInfoInput, SubmitDisabled: false });
  };
  const VehcileHeadTable = () => (
    <>
      {VehicleHeadArr.map((col, index) => {
        return <RACTableCell key={index}>{t(col.displayName)}</RACTableCell>;
      })}
    </>
  );
  const VehicleBodyTable = () => (
    <>
      {VehicleDetailsArray.map((col, index) => {
        return (
          <RACTableRow key={index} hover backgroundColor="white">
            <RACTableCell>
              {
                <RACRadio
                  value=""
                  checked={VehcileInfoChxboxState[index]}
                  onChange={() => VehicleInfoChxboxOnchnage(index)}
                />
              }
            </RACTableCell>
            <RACTableCell>{col.vehicleMake}</RACTableCell>
            <RACTableCell>{col.vehicleModel}</RACTableCell>
            <RACTableCell>{col.vehicleYear}</RACTableCell>
            <RACTableCell>{col.vehicleVin}</RACTableCell>
          </RACTableRow>
        );
      })}
    </>
  );
  const ConfirmDueDateNoClick = () => {
    setNextBtnClicked(false);
    setPopupOpen({ ...PopupOpen, ConfirmDueDateOpen: false });
  };
  const ConfirmDueDate = () => {
    return (
      <Grid className="">
        <Grid className={classes.textCenter}>
          <Typography>
            {t("Please confirm first renewal payment date")}{' '}
            <Typography className={`${classes.mt2} ${classes.fontBold}`}>
              {NextDueDate}
            </Typography>
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="outlined"
            color="primary"
            onClick={() => ConfirmDueDateNoClick()}
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => ConfirmDueDateAction()}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const CreateVehiclePopup = () => {
    return (
      <Grid
        className={classes.ps3}
        id="Customer-Signature"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid container spacing={2}>
          <Grid item md={6}>
            <RACTextbox
              type="text"
              inputlabel={t("Make")}
              maxlength={14}
              id="vehicle_make"
              required={true}
              name="Make"
              value={CreateVehicleInputs.Make}
              OnChange={(e: any) => CreateVehicleInputOnchange(e)}
              isCurrency={false}
            />
          </Grid>
          <Grid item md={6}>
            <RACTextbox
              required={true}
              name="Model"
              value={CreateVehicleInputs.Model}
              OnChange={(e) => CreateVehicleInputOnchange(e)}
              isCurrency={false}
              inputlabel={t("Model")}
              type="text"
              maxlength={14}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={6}>
            <RACSelect
              inputLabel={t("Year")}
              options={YearOfVehcileArray}
              defaultValue={CreateVehicleInputs.Year}
              required={true}
              name="Year"
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                CreateVehicleYearOnchange(e);
              }}
            />
          </Grid>
          <Grid item md={6}>
            <RACTextbox
              required={true}
              name="VIN"
              value={CreateVehicleInputs.VIN}
              OnChange={(e) => CreateVehicleInputOnchange(e)}
              isCurrency={false}
              inputlabel={t("VIN#")}
              type="text"
              maxlength={14}
            />
          </Grid>
          <Grid item md={6}>
            <RACTextbox
              required={true}
              name="VehicleLicensePlate"
              value={CreateVehicleInputs.VehicleLicensePlate}
              OnChange={(e) => CreateVehicleInputOnchange(e)}
              isCurrency={false}
              inputlabel={t("Vehicle License Plate")}
              type="text"
              maxlength={14}
            />
          </Grid>
        </Grid>
        <Grid
          className={`${classes.popupFooter} ${classes.pb4} ${classes.px3}`}
        >
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.mx1}
            onClick={() => CreateVehicleCancelClick()}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            disabled={CreateVehicleControls.CreateVehicleSubmit}
            onClick={() => CreateVehicleSubmitClick()}
          >
            {t("Submit")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const VehicleInfoPopup = () => {
    return (
      <Grid
        className={classes.p3}
        id="vehicle-Info"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={`${classes.w100} ${classes.floatLeft} ${classes.mb4}`}>
          <Typography
            variant="h5"
            className={`${classes.font16} ${classes.semiBold} ${classes.floatLeft} ${classes.mb3}`}
          >
            {t("Vehicle Details")}
          </Typography>
          <RACButton
            variant="contained"
            color="primary"
            className={`${classes.mx1} ${classes.floatRight}`}
            onClick={() => CreateVehicleClick()}
          >
            {t("Create Vehicle")}
          </RACButton>
        </Grid>
        <Grid>
          {VehicleDetailsArray !== undefined ? (
            <RACTable
              className={`${classes.racGrid} ${classes.mb32}`}
              renderTableHead={VehcileHeadTable}
              renderTableContent={VehicleBodyTable}
            />
          ) : null}
        </Grid>
        <Grid>
          <Grid className={`${classes.pb4} ${classes.px3}`}></Grid>
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.mx1}
            onClick={() =>
              setPopupOpen({ ...PopupOpen, VehicleInfoOpen: false })
            }
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            disabled={VehicleInfoInput.SubmitDisabled}
            onClick={() => VehicleInfoSubmitClick()}
          >
            {t("Submit")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const ProcessingFee = () => {
    return (
      <Grid>
        <Grid container className={classes.mb4}>
          <Typography className={`${classes.w50} ${classes.formLabel}`}>
            {t("Processing Fee Amount")}
          </Typography>
          <Grid className={`${classes.w50} ${classes.floatLeft}`}>
            <RACTextbox
              isCurrency={true}
              value="0"
              className={'text'}
              dollarTextClassName={'dollar'}
              digitFormat="currency"
              disabled={true}
              OnChange={(e) => console.log(e)}
            />
          </Grid>
        </Grid>

        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
          >
            {' '}
            {t("Override Amount")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  //PS_AD-1 below function will return all the div tags for auto pay popup
  const AutopayPopupup = () => {
    return (
      <Grid>
        {AutopayCustomerInfo.CustomerPhoneNumber !== '' ? (
          <Grid>
            <Grid className={autoPayClassName.autoPayContainer}>
              <Grid container>
                <Grid
                  item
                  md={12}
                  className={`${autoPayClassName.autoPayTitle} ${classes.textCenter} ${classes.mb3}`}
                >
                  {t("Discuss the benefits of Autopay and enroll your customer today")}
                </Grid>

                <Grid
                  container
                  className={`${classes.mb3} ${classes.justifyCenter}`}
                >
                  <Grid item lg={10}>
                    <Grid xs="auto" className={classes.floatLeft}>
                      <Typography
                        className={`${autoPayClassName.autoPayValue} ${classes.me2}`}
                      >
                        1
                      </Typography>
                    </Grid>
                    <Grid xs="auto" className={classes.floatLeft}>
                      <Typography
                        variant="caption"
                        className={`${autoPayClassName.autoPaySubTitle} ${classes.w100} ${classes.floatLeft} ${classes.mb1}`}
                      >
                        {t("Convenience")}
                      </Typography>
                      <Typography
                        variant="caption"
                        className={`${autoPayClassName.autoPaySubTitleAccent} ${classes.w100} ${classes.floatLeft}`}
                      >
                        {t("Save Customer Time")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  className={`${classes.mb3} ${classes.justifyCenter}`}
                >
                  <Grid item lg={10} style={{ display: 'flex' }}>
                    <Grid xs="auto" className={classes.floatLeft}>
                      <Typography
                        className={`${autoPayClassName.autoPayValue} ${classes.me2}`}
                      >
                        2
                      </Typography>
                    </Grid>
                    <Grid xs="auto" className={classes.floatLeft}>
                      <Typography
                        variant="caption"
                        className={`${autoPayClassName.autoPaySubTitle} ${classes.w100} ${classes.floatLeft} ${classes.mb1}`}
                      >
                        {t("Zero Fees")}
                      </Typography>
                      <Typography
                        variant="caption"
                        className={`${autoPayClassName.autoPaySubTitleAccent} ${classes.w100} ${classes.floatLeft}`}
                      >
                        {t("Avoid convenience/phone fees")}{' '}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  className={`${autoPayClassName.autoPayFormCheck} ${classes.mb3}`}
                >
                  <RACCheckBox
                    className={`${classes.floatLeft} ${classes.textCenter}`}
                    onClick={() => AutopayChkboxAction()}
                    checked={AutopayInput.AutopayChkBox}
                    label={t("Customer has verbally consented to receive this text message")}
                  />
                </Grid>
                <Typography
                  className={`${autoPayClassName.autoPayPrimaryRenter} ${classes.my3}`}
                >
                  {t("Autopay will be associated with the Primary Renter")}
                </Typography>
                <Grid container className={autoPayClassName.justifycenter}>
                  <Grid item md={8}>
                    <Grid
                      className={`${classes.w100} ${classes.floatLeft} ${classes.mb2}`}
                      style={{ width: '400px' }}
                    >
                      <Typography
                        variant="caption"
                        className={`${classes.me3} ${autoPayClassName.autoPayTxtStyle}`}
                      >
                        {' '}
                        {t("Customer Name")}
                      </Typography>
                      <Typography
                        variant="caption"
                        className={autoPayClassName.autoPayLabelTxt}
                      >
                        {' '}
                        {AutopayCustomerInfo.CustomerName}
                      </Typography>
                    </Grid>
                    <Grid className={`${classes.w100} ${classes.floatLeft}`}>
                      <Typography
                        variant="caption"
                        className={`${classes.me3} ${autoPayClassName.autoPayTxtStyle}`}
                      >
                        {t("Phone Number")}
                      </Typography>
                      <Typography
                        variant="caption"
                        className={autoPayClassName.autoPayLabelTxt}
                      >
                        {' '}
                        {AutopayCustomerInfo.CustomerPhoneNumber}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              md={12}
              className={`${classes.py4} ${classes.textCenter}`}
            >
              <RACButton
                variant="outlined"
                color="primary"
                className={classes.mx1}
                onClick={() => AutoPayNotnowClick()}
              >
                {t("Not now")}
              </RACButton>
              <RACButton
                variant="contained"
                color="primary"
                className={classes.mx1}
                disabled={AutopayInput.AutoPaySubmitDisable}
                onClick={() => AutoPaySubmitClick()}
              >
                {t("Send Text at Payment")}
              </RACButton>
            </Grid>
          </Grid>
        ) : (
          <Grid>
            <Grid>
              <Grid className={classes.textCenter}>
                <Typography className={classes.formLabel}>
                  {' '}
                  {t("The TXT to Autopay signup functionality is not available without a Cell Phone #")}
                </Typography>
                <Typography className={classes.formLabel}>
                  {' '}
                  {t("Please add a Cell Phone # before attempting to send an AutoPay signup text")}
                </Typography>
              </Grid>
              <Grid
                item
                md={12}
                className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
              >
                <RACButton
                  className={classes.mx1}
                  variant="contained"
                  color="primary"
                  onClick={() => AutoPayNotnowClick()}
                >
                  {t("Ok")}
                </RACButton>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  };
  const IntialPayment = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography className={classes.mb4}>
            {t("Do you want to take initial payment?")}
          </Typography>
        </Grid>
        <Grid className={`${classes.pb4} ${classes.textCenter}`}>
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.mx1}
            onClick={() => InitialPaymentNoBtnclick()}
          >
            {t("No")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            onClick={() => InitialPaymentOnclick()}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const ConfirmDueDateCloseClick = () => {
    setPopupOpen({ ...PopupOpen, ConfirmDueDateOpen: false });
    setNextBtnClicked(false);
  };
  const customerSignatureCompletedFn = () => {
    setPopupOpen({ ...PopupOpen, InitialPaymentOpen: true });
    setPopupCompleteStatus({
      ...PopupCompleteStatus,
      CustomerSignComplete: true,
    });
  };
  const emailcompletedFn = () => {
    setPopupOpen({ ...PopupOpen, InitialPaymentOpen: true });
    setPopupCompleteStatus({
      ...PopupCompleteStatus,
      CustomerSignComplete: true,
    });
  };
  const customerSignatureCanceledFn = () => {
    setPopupOpen({ ...PopupOpen, CustomerSignOpen: false });
  };
  return (
    <Grid>
      {HiddenLoader === true ? <HideLoader /> : null}
      <RACModalCard
        isOpen={CreateAgrProcessingPopup}
        closeIcon={false}
        maxWidth="xs"
        children={CreateAgreementProcessingPopup()}
        borderRadius={'20px !important'}
      />
      <RACModalCard
        isOpen={CreateAgrFailPopup}
        closeIcon={false}
        maxWidth="xs"
        children={CreateAgreementFailPopup()}
        borderRadius={'20px !important'}
      />
      <RACModalCard
        isOpen={SomethingWentWrongOpen}
        closeIcon={false}
        maxWidth="xs"
        children={SomethingWentWrongPopup()}
        borderRadius={'20px !important'}
      />

      <RACModalCard
        isOpen={PopupOpen.ConfirmDueDateOpen}
        title={t("Confirm Due Date")}
        TitleVariantClassName={classes.popupTitle}
        closeIcon={true}
        onClose={() => ConfirmDueDateCloseClick()}
        maxWidth="xs"
        children={ConfirmDueDate()}
        borderRadius={'20px !important'}
      />

      <RACModalCard
        isOpen={PopupOpen.AutoPayOpen}
        closeIcon={
          AutopayCustomerInfo.CustomerPhoneNumber !== '' ? true : false
        }
        onClose={() => AutoPayCloseClick()}
        maxWidth="sm"
        children={AutopayPopupup()}
        borderRadius={'20px !important'}
      />

      <RACModalCard
        isOpen={PopupOpen.CreateVehicleOpen}
        closeIcon={true}
        maxWidth="sm"
        title={t("Create Vehicle")}
        children={CreateVehiclePopup()}
        onClose={() => {
          setPopupOpen({ ...PopupOpen, CreateVehicleOpen: false });
        }}
        borderRadius={'20px !important'}
      />

      <RACModalCard
        isOpen={PopupOpen.VehicleInfoOpen}
        closeIcon={true}
        maxWidth="sm"
        title={t("Vehicle Information")}
        children={VehicleInfoPopup()}
        onClose={() => {
          setPopupOpen({ ...PopupOpen, VehicleInfoOpen: false });
        }}
        borderRadius={'20px !important'}
      />
      <RACModalCard
        isOpen={PopupOpen.ProcessingFeePopupOpen}
        closeIcon={true}
        onClose={() =>
          setPopupOpen({ ...PopupOpen, ProcessingFeePopupOpen: false })
        }
        maxWidth="xs"
        children={ProcessingFee()}
        borderRadius={'20px !important'}
      />

      <RACModalCard
        isOpen={PopupOpen.InitialPaymentOpen}
        closeIcon={true}
        onClose={() => InitialPaymentCloseClick()}
        maxWidth="xs"
        children={IntialPayment()}
        borderRadius={'20px !important'}
      />
      <RACModalCard
        isOpen={ErrorMsgPopupOpen}
        closeIcon={false}
        maxWidth="xs"
        children={ErrorMsgPopup()}
        borderRadius={'20px !important'}
      />
      {PopupOpen.CustomerSignOpen ? (
        <CustomerSignature
          customerSignUsingField="agreementDetails"
          customerSignUsingModule="rental"
          identifier={parseInt(AgreementId)}
          customersArr={AgrCustomerObj}
          manualSignOptions={ManualSignOptions}
          documentTypeArr={[]}
          customerSignatureCompletedFn={() => customerSignatureCompletedFn()}
          customerSignatureCanceledFn={() => customerSignatureCanceledFn()}
          emailcompletedFn={() => emailcompletedFn()}
          documentGenerateCompleted={documentGenerateCompleted}
        />
      ) : null}
      {SomethingWentWrong === true ? (
        <div
          className="Norecords"
          style={{ marginTop: '20%', marginLeft: '40%' }}
        >
          <Alerticon></Alerticon>
          {t("Something went wrong!")}
        </div>
      ) : (
        <Grid className={classes.px2}>
          <GeneralInformation
            ref={childCompRef}
            PaymentScheduleValues={PaymentScheduleValues}
            CustomerCoverageData={CustomerCoverageData}
            IsPendingAgreement={IsPendingAgreement}
            PendingAgreementOptions={PendingAgreementOptions}
            PendingAgreementDropdownValues={PendingAgreementDropdownValues}
            settempSchedule={settempSchedule}
            DeliveryChargeDisable={DeliveryChargeDisable}
            DeliveryChargeFeeValues={DeliveryChargeFeeValues}
            EditDisablemode={EditDisablemode}
            setExtAmt={setExtAmt}
            PopupOpen={PopupOpen}
            AutoPayToggleStatus={AutoPayToggleStatus}
            setAutoPayToggleStatus={setAutoPayToggleStatus}
            TireAgreement={TireAgreement}
            PolicyEnabled={PolicyEnabled}
            setNextBtnDisabled={setNextBtnDisabled}
            PayScheduleValues={PayScheduleValues}
            RecalculateClicked={RecalculateClicked}
            CalenderDuedate={CalenderDuedate}
            AgreementSchedule={AgreementSchedule}
            EmployerPayschedule={EmployerPayschedule}
            CustomerID={CustomerID}
            StoreNumber={StoreNumber}
            GeneralInfoInputsChanged={GeneralInfoInputsChanged}
            throwStyle={classes}
            ClubStatus={ClubStatus}
            ClubOriginStore={ClubOriginStore}
            IsLdwTiedWithClub={IsLdwTiedWithClub}
            LDWstatus={LDWstatus}
            waiveLDWChecked={waiveLDWChecked}
            setWaiveLDWChecked={setWaiveLDWChecked}
          />
          <PaymentCost
            EditDisablemode={EditDisablemode}
            Openlogin={Openlogin}
            ExtAmt={ExtAmt}
            TireAgreement={TireAgreement}
            PolicyEnabled={PolicyEnabled}
            InitialPaymentValues={InitialPaymentValues}
            TotalPaymentValues={TotalPaymentValues}
            OtherFeeArray={OtherFeeArray}
            AgreementTotal={AgreementTotal}
            OtherAmtChanged={OtherAmtChanged}
            SacChanged={SacChanged}
            CurrentRole={CurrentRole}
            throwStyle={classes}
            PaymentCostLoading={PaymentCostLoading}
            setPaymentCostLoading={setPaymentCostLoading}
          />
          <Grid className={classes.fixedBottom}>
            <RACButton
              className={`${classes.mx1} ${classes.floatLeft}`}
              variant="outlined"
              color="primary"
              onClick={() => PreviousBtnClick()}
            >
              {t("Previous")}
            </RACButton>
            {IsAgreementVoided !== true ? (
              <Grid title={NextBtnMessage} style={{ float: 'right' }}>
                <RACButton
                  className={`${classes.me2} ${classes.floatRight}`}
                  variant="contained"
                  color="primary"
                  onClick={() => NextBtnClick()}
                  disabled={NextBtnDisabled}
                >
                  {t("Next")}
                </RACButton>
              </Grid>
            ) : null}
            {IsAgreementVoided !== true ? (
              <div style={{ float: 'right' }}>
                <AddCocustomer func={pulls_data} />
              </div>
            ) : null}
            {VoidEnabled === true &&
              IsAgreementVoided !== true &&
              InitialPaymentPaid === false &&
              reinstateDone ? (
              <VoidAgreement
                AgreementId={AgreementId}
                customerId={CustomerID}
                func={pull_data}
              />
            ) : null}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
